import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { api } from "@/lib/api";
import AuthShell, { Field, SubmitButton, ErrorNote } from "@/pages/Login";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    birthday: "",
    registration_key: "",
  });
  const [keyRequired, setKeyRequired] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api
      .get("/auth/status")
      .then(({ data }) => setKeyRequired(data.registration_key_required))
      .catch(() => setKeyRequired(false));
  }, []);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const payload = { ...form };
      if (!keyRequired) delete payload.registration_key;
      await register(payload);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your account"
      subtitle={
        keyRequired
          ? "You're the first user — this account becomes the admin. A registration key is required."
          : "Join and start reflecting week by week."
      }
      footer={
        <span>
          Already have an account?{" "}
          <Link to="/login" className="text-foreground hover:underline" data-testid="login-link">
            Sign in
          </Link>
        </span>
      }
    >
      <form onSubmit={submit} data-testid="register-form">
        <ErrorNote message={error} />
        <Field label="Name" value={form.name} onChange={update("name")} required data-testid="register-name" />
        <Field
          label="Email"
          type="email"
          value={form.email}
          onChange={update("email")}
          required
          data-testid="register-email"
        />
        <Field
          label="Password"
          type="password"
          value={form.password}
          onChange={update("password")}
          required
          minLength={8}
          placeholder="At least 8 characters"
          data-testid="register-password"
        />
        <Field
          label="Birthday"
          type="date"
          value={form.birthday}
          onChange={update("birthday")}
          required
          data-testid="register-birthday"
        />
        {keyRequired && (
          <Field
            label="Registration key"
            value={form.registration_key}
            onChange={update("registration_key")}
            required
            placeholder="Admin registration key"
            data-testid="register-key"
          />
        )}
        <SubmitButton loading={loading} data-testid="register-submit">
          Create account
        </SubmitButton>
      </form>
    </AuthShell>
  );
}
